import { Flex } from '@/components';
import { AnnouncementRichText } from '@/components/common/AnnouncementRichText';

const AnnouncementItem = ({
  title,
  mainText,
  onClick,
}: AnnouncementEntity & { onClick: () => void }) => {
  return (
    <Flex
      align="center"
      direction="row"
      onClick={() => onClick()}
      className="announcement-item">
      <Flex inlineFlex direction="column" className="gap-1 w-full min-w-0">
        <b>{title}</b>
        <AnnouncementRichText
          html={mainText}
          preview
          previewLines={2}
          className="text-sm text-app-gray-darker"
        />
      </Flex>
    </Flex>
  );
};

export default AnnouncementItem;
